import { render, staticRenderFns } from "./particles.vue?vue&type=template&id=af1fc11e&scoped=true&"
import script from "./particles.vue?vue&type=script&lang=js&"
export * from "./particles.vue?vue&type=script&lang=js&"
import style0 from "./particles.vue?vue&type=style&index=0&id=af1fc11e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1fc11e",
  null
  
)

export default component.exports